const salutations = ['-', 'Dr.','Ms.','Mrs.','Mr.', 'Mx.']

export default salutations
